import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CCompanyInfoViewModel } from './models/commonInformation.models/commonInformation.model';
import { API_ServerAddress } from './MyAppCommonConfig';
import { CommonInformationService } from './services/commonInformation.service';
import { themservice } from './services/them.service';
import { CSocialNetworkLink } from './models/links.models/socialNetworkLink.model';
import { SocialNetworkLinkService } from './services/socialNetworkLink.service';
import { CUsefulLink } from './models/links.models/usefulLink.model';
import { UsefulLinkService } from './services/usefulLink.service';
import { CPhotoGaleryGroup } from './models/galery.models/photoGaleryGroup.model';
import { PhotoGaleryGroupService } from './services/photoGaleryGroup.service';
import { PageService } from './services/page.service';
import { CPage } from './models/page.models/page.model';
import { PageRootMenuViewModel } from './models/page.models/pageRootMenuViewModel.model';
import { HttpClient } from '@angular/common/http';
import { CDateTimeViewModel } from './models/commonInformation.models/dateTimeViewModel.model';
declare var $:any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  ngOnInit(): void {
    this.GetCommonInfo();
    this.GetSocialNetworkLinkArray();
    this.GetUsefulLinkArray();
    this.GetPhotoGaleryGroupArray();
    this.GetPageArray();
    this.GetNowDateInfo();

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

  title = 'app';
  ApiServiceAddress: string;
  commonInformation: CCompanyInfoViewModel = new CCompanyInfoViewModel();
  nowDateInfo:CDateTimeViewModel=new CDateTimeViewModel();
  socialNetworkLinkArray: CSocialNetworkLink[] = [];
  useFulLinkArray: CUsefulLink[] = [];
  photoGaleryGroupArray: CPhotoGaleryGroup[] = [];
  pageArray: CPage[] = [];
  pageRootMenuViewModelArray: PageRootMenuViewModel[] = [];

  laboratoriesAnsweringLink: string = '';
  organizationsAnsweringLink: string = '';
  doctorsAnsweringLink: string = '';
  //SelectedTemId:number=0;

  constructor(private router: Router, private commonInformationService: CommonInformationService,private themservice: themservice, private socialNetworkLinkService: SocialNetworkLinkService,
    private usefulLinkService: UsefulLinkService, private photoGaleryGroupService: PhotoGaleryGroupService, private pageService: PageService,private http:HttpClient) {

    this.ApiServiceAddress = API_ServerAddress;
    this.laboratoriesAnsweringLink = API_ServerAddress + 'OnlineServices/Laboratories';
    this.organizationsAnsweringLink = API_ServerAddress + 'OnlineServices/Organizations';
    this.doctorsAnsweringLink = API_ServerAddress + 'OnlineServices/Doctors';
  }
  ngAfterViewInit(): void {
    

  }
 
  GetNowDateInfo() {
    
    this.commonInformationService.NowDateInfo()
      .subscribe((data: CDateTimeViewModel) => this.nowDateInfo = data);
  }
  GetCommonInfo() {
    this.commonInformationService.GetInfo()
      .subscribe((data: CCompanyInfoViewModel) => this.commonInformation = data);
  }
 
  GetSocialNetworkLinkArray() {
    this.socialNetworkLinkService.GetList().subscribe((data: CSocialNetworkLink[]) => this.socialNetworkLinkArray = data);
  }

  GetUsefulLinkArray() {
    this.usefulLinkService.GetList().subscribe((data: CUsefulLink[]) => this.useFulLinkArray = data);
  }

  GetPhotoGaleryGroupArray() {
    this.photoGaleryGroupService.GetList().subscribe((data: CPhotoGaleryGroup[]) => this.photoGaleryGroupArray = data);
  }

  GetPageArray() {
    this.pageService.GetList(null)
      .subscribe((data: CPage[]) => {
        this.pageArray = data;

        this.processMenu();
      });
  }

  processMenu() {
    let rootPageArray = this.pageArray.filter(p => p.fParentId === 0);
    rootPageArray.forEach(element => {
      let rootObj = new PageRootMenuViewModel();
      rootObj.fId = element.fId;
      rootObj.fSubject = element.fSubject;

      this.setSubMenu(rootObj);

      this.pageRootMenuViewModelArray.push(rootObj);
    });
  }

  setSubMenu(rootObj: PageRootMenuViewModel){
    let subItems=this.pageArray.filter(p=>p.fParentId===rootObj.fId);
    if(subItems.length>0){
      rootObj.fHasSubMenu=true;
      subItems.forEach(subElement => {
        let subObj = new PageRootMenuViewModel();
        subObj.fId = subElement.fId;
        subObj.fSubject = subElement.fSubject;

        rootObj.PageSubMenuViewModelArray.push(subObj);

        this.setSubMenu(subObj);
      })
    }
  }
}
